import { z } from '@uturn/portal/zod';

export const leadFormSchema = z.object({
	email: z.string().trim().email(),
});

export type LeadFormFields = z.infer<typeof leadFormSchema>;
